import React from 'react';
import PropTypes from 'prop-types';

const BodyChildContainer = (props) => {
  const { children } = props;
  return (
    <div className="relative w-full">
      { children }
    </div>
  );
};

BodyChildContainer.propTypes = {
  children: PropTypes.shape().isRequired,
};

export default BodyChildContainer;
